/* pdp-v2: new product page. Loaded once by sections/iva-pdp-main.liquid.
   Depends on theme globals already on the page (pubsub.js, global.js, product-variants.js, cart.js); never re-declares them. */
(function () {
  'use strict';
  if (window.__ipdLoaded) return;
  window.__ipdLoaded = true;

  const root = document.querySelector('[data-ipd-root]');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  const suffix = root.dataset.templateSuffix;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const L = root.dataset;

  /* 1. Variant fetches must render THIS template: append &view=<suffix> (needed for ?view preview and template tests). */
  if (suffix) {
    customElements.whenDefined('product-info').then(() => {
      const PI = customElements.get('product-info');
      const proto = PI && PI.prototype;
      if (!proto || proto.__ipdPatched || typeof proto.buildRequestUrlWithParams !== 'function') return;
      const original = proto.buildRequestUrlWithParams;
      proto.buildRequestUrlWithParams = function () {
        const url = original.apply(this, arguments);
        if (this.dataset && this.dataset.section === sectionId && !/[?&]view=/.test(url)) {
          return url + (url.includes('?') ? '&' : '?') + 'view=' + encodeURIComponent(suffix);
        }
        return url;
      };
      proto.__ipdPatched = true;
    });
  }

  const onVariantChange = (cb) => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event && event.data && event.data.sectionId === sectionId) cb(event.data);
    });
  };

  /* 2. Gallery */
  function initGallery() {
    const g = root.querySelector('[data-ipd-gallery]');
    if (!g) return;
    const stage = g.querySelector('[data-ipd-stage]');
    const frame = g.querySelector('[data-ipd-frame]');
    const slides = Array.from(g.querySelectorAll('[data-ipd-slide]'));
    const count = g.querySelector('[data-ipd-count]');
    const goButtons = Array.from(g.querySelectorAll('[data-ipd-go]'));
    if (!slides.length) return;
    let current = 0;
    let inView = false;

    const videoOf = (i) => slides[i] && slides[i].querySelector('video');
    const canPlay = () => !reduceMotion.matches && !document.hidden && !(navigator.connection && navigator.connection.saveData);

    function syncVideo() {
      slides.forEach((s, i) => {
        const v = s.querySelector('video');
        if (!v) return;
        if (i === current && inView && canPlay()) {
          if (!v.src && v.dataset.src) v.src = v.dataset.src;
          v.muted = true;
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }

    function show(n) {
      const len = slides.length;
      current = ((n % len) + len) % len;
      slides.forEach((s, i) => { s.hidden = i !== current; });
      stage.dataset.kind = slides[current].dataset.kind || 'photo';
      if (count) count.textContent = (current + 1) + ' / ' + len;
      goButtons.forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.ipdGo) === current)));
      const thumb = g.querySelector('.ipd-gallery__thumb[aria-pressed="true"]');
      if (thumb && thumb.parentElement.scrollWidth > thumb.parentElement.clientWidth) {
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      const next = slides[(current + 1) % len].querySelector('img[loading="lazy"]');
      if (next) next.loading = 'eager';
      syncVideo();
    }

    g.querySelector('[data-ipd-prev]')?.addEventListener('click', () => show(current - 1));
    g.querySelector('[data-ipd-next]')?.addEventListener('click', () => show(current + 1));
    goButtons.forEach((b) => b.addEventListener('click', () => show(Number(b.dataset.ipdGo))));

    let sx = 0; let sy = 0;
    frame.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    frame.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
    g.addEventListener('keydown', (e) => {
      if (e.target.closest('input, select, textarea')) return;
      if (e.key === 'ArrowRight') show(current + 1);
      if (e.key === 'ArrowLeft') show(current - 1);
    });

    slides.forEach((s) => {
      const v = s.querySelector('video');
      if (v) v.addEventListener('error', () => { v.removeAttribute('src'); v.load(); }, { once: true });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
        syncVideo();
      }, { threshold: 0.35 }).observe(stage);
    } else {
      inView = true;
    }
    document.addEventListener('visibilitychange', syncVideo);
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', syncVideo);

    onVariantChange(({ variant }) => {
      const id = variant && variant.featured_media && variant.featured_media.id;
      if (!id) return;
      const i = slides.findIndex((s) => String(s.dataset.mediaId) === String(id));
      if (i > -1) show(i);
    });

    show(0);
  }

  /* 3. Purchase choice (one-time / subscription) */
  const productForm = () => root.querySelector('product-form');
  const submitBtn = () => document.getElementById('ProductSubmitButton-' + sectionId);
  let mode = 'once';
  let planIndex = 0;

  function applyPurchase() {
    const wrap = root.querySelector('[data-ipd-purchase]');
    const pf = productForm();
    const btn = submitBtn();
    let price = null;
    let modeText = L.labelOnce || '';
    if (wrap) {
      const requires = wrap.dataset.requiresPlan === 'true';
      if (requires) mode = 'subscription';
      const input = wrap.querySelector('[data-ipd-plan-input]');
      const planBox = wrap.querySelector('[data-ipd-plan]');
      const buttons = Array.from(wrap.querySelectorAll('[data-ipd-plan-id]'));
      if (planIndex >= buttons.length) planIndex = 0;
      wrap.querySelectorAll('[data-ipd-choice]').forEach((c) => {
        const on = c.dataset.ipdChoice === mode;
        c.classList.toggle('is-selected', on);
        const r = c.querySelector('input[type="radio"]');
        if (r) r.checked = on;
      });
      buttons.forEach((b, i) => b.setAttribute('aria-pressed', String(i === planIndex)));
      const chosen = buttons[planIndex];
      if (planBox) planBox.hidden = mode !== 'subscription';
      if (input) {
        input.disabled = mode !== 'subscription' || !chosen;
        if (chosen) input.value = chosen.dataset.ipdPlanId;
      }
      if (mode === 'subscription' && chosen) {
        const expl = wrap.querySelector('[data-ipd-expl]');
        if (expl) expl.textContent = chosen.dataset.expl || '';
        const subPrice = wrap.querySelector('[data-ipd-sub-price]');
        if (subPrice) subPrice.textContent = chosen.dataset.price;
        const saving = wrap.querySelector('[data-ipd-saving]');
        if (saving) {
          const pct = Number(chosen.dataset.pct || 0);
          saving.textContent = pct > 0 ? saving.dataset.template.replace('[pct]', pct) : '';
        }
        price = chosen.dataset.price + ' ' + (L.labelPerDelivery || '');
        modeText = (L.labelSub || '') + ' · ' + (chosen.dataset.mode || '');
      } else {
        const once = wrap.querySelector('[data-ipd-once-price]');
        if (once) price = once.textContent.trim();
      }
    }
    if (pf) pf.toggleAttribute('data-has-selling-plan', mode === 'subscription');
    if (btn && !btn.hasAttribute('disabled')) {
      const span = btn.querySelector('span');
      if (span) span.textContent = mode === 'subscription' ? L.labelAddSub : L.labelAdd;
    }
    updateStickyContent(price, modeText);
  }

  function initPurchase() {
    root.addEventListener('change', (e) => {
      const r = e.target.closest('[data-ipd-purchase] input[type="radio"]');
      if (!r) return;
      mode = r.value === 'subscription' ? 'subscription' : 'once';
      applyPurchase();
    });
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-ipd-plan-id]');
      if (!b) return;
      const all = Array.from(b.parentElement.querySelectorAll('[data-ipd-plan-id]'));
      planIndex = all.indexOf(b);
      mode = 'subscription';
      applyPurchase();
    });
    onVariantChange(({ html }) => {
      const id = 'IvaPurchase-' + sectionId;
      const src = html && html.getElementById(id);
      const dst = document.getElementById(id);
      if (dst) {
        if (src && src.innerHTML.trim()) { dst.innerHTML = src.innerHTML; dst.hidden = false; } else { dst.innerHTML = ''; dst.hidden = true; mode = 'once'; }
      }
      applyPurchase();
    });
    applyPurchase();
  }

  /* 4. Sticky bar */
  const sticky = document.querySelector('[data-ipd-sticky]');
  function currentPrice() {
    const p = document.getElementById('price-' + sectionId);
    if (!p) return '';
    const el = p.querySelector('ins ins') || p.querySelector('.price__regular span:not(.visually-hidden)') || p.querySelector('ins span:not(.visually-hidden)');
    return el ? el.textContent.trim() : '';
  }
  function updateStickyContent(price, modeText) {
    if (!sticky) return;
    const priceEl = sticky.querySelector('[data-ipd-sticky-price]');
    const modeEl = sticky.querySelector('[data-ipd-sticky-mode]');
    const label = sticky.querySelector('[data-ipd-sticky-label]');
    const btn = sticky.querySelector('[data-ipd-sticky-btn]');
    if (priceEl) priceEl.textContent = price || currentPrice();
    const variantLabel = (root.querySelector('product-variant-selects [data-selected-value], [data-ipd-single-variant]') || {}).textContent;
    if (modeEl) modeEl.textContent = mode === 'subscription' ? modeText : [variantLabel && variantLabel.trim(), L.labelOnce].filter(Boolean).join(' · ');
    if (label) label.textContent = mode === 'subscription' ? L.labelStickyAddSub : L.labelStickyAdd;
    const main = submitBtn();
    if (btn && main) btn.disabled = main.hasAttribute('disabled');
  }
  function initSticky() {
    if (!sticky) return;
    const btn = sticky.querySelector('[data-ipd-sticky-btn]');
    const err = sticky.querySelector('[data-ipd-sticky-error]');
    const h1 = root.querySelector('.ipd-summary__title');
    const footer = document.querySelector('footer, .footer, #shopify-section-footer, [id*="__footer"]');
    const spacer = document.createElement('div');
    spacer.className = 'ipd-sticky-spacer';
    spacer.hidden = true;
    sticky.after(spacer);

    function update() {
      const main = submitBtn();
      if (!main || !h1) return;
      const r = main.getBoundingClientRect();
      const offscreen = r.bottom < 0 || r.top > window.innerHeight;
      const reached = h1.getBoundingClientRect().top < window.innerHeight - 120;
      const footerIn = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      const drawerOpen = !!document.querySelector('cart-drawer.is-visible, cart-drawer.active');
      const visible = offscreen && reached && !footerIn && !drawerOpen;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
      btn.tabIndex = visible ? 0 : -1;
      spacer.hidden = !visible;
    }
    btn.addEventListener('click', () => {
      const main = submitBtn();
      if (!main || main.hasAttribute('disabled') || main.getAttribute('aria-disabled') === 'true') return;
      main.click();
    });
    const main = submitBtn();
    if (main) {
      new MutationObserver(() => {
        const busy = main.classList.contains('loading') || main.getAttribute('aria-disabled') === 'true';
        btn.setAttribute('aria-busy', String(busy));
        btn.disabled = main.hasAttribute('disabled') || busy;
      }).observe(main, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
    }
    const errWrap = root.querySelector('.product-form__error-message-wrapper');
    if (errWrap && err) {
      new MutationObserver(() => {
        const hidden = errWrap.hasAttribute('hidden');
        err.hidden = hidden;
        err.textContent = hidden ? '' : errWrap.textContent.trim();
      }).observe(errWrap, { attributes: true, childList: true, subtree: true });
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(update).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    onVariantChange(() => update());
    update();
  }

  /* 5. Rating link opens the reviews tab */
  function initRatingLink() {
    root.querySelectorAll('[data-ipd-open-reviews]').forEach((a) => {
      a.addEventListener('click', (e) => {
        const tabs = document.querySelector('[data-ipd-tabs]');
        if (!tabs) return;
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('ipd:open-tab', { detail: { tab: 'reviews', scroll: true } }));
      });
    });
  }

  /* 6. Range carousel + add to cart (same request as the theme's product form) */
  function initRange() {
    const range = root.querySelector('[data-ipd-range]');
    if (!range) return;
    const track = range.querySelector('[data-ipd-range-track]');
    const prev = range.querySelector('[data-ipd-range-prev]');
    const next = range.querySelector('[data-ipd-range-next]');
    const step = () => {
      const card = track.querySelector('.ipd-range__card');
      return card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
    };
    const updateArrows = () => {
      if (prev) prev.disabled = track.scrollLeft < 3;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
    };
    const behavior = () => (reduceMotion.matches ? 'auto' : 'smooth');
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: behavior() }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: behavior() }));
    track.addEventListener('scroll', updateArrows, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(updateArrows).observe(track);
    updateArrows();

    range.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-ipd-range-add]');
      if (!btn || btn.disabled) return;
      const card = btn.closest('.ipd-range__card');
      const err = card && card.querySelector('.ipd-range__error');
      const label = btn.querySelector('span');
      const original = label ? label.textContent : '';
      const variantId = btn.dataset.ipdRangeAdd;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (err) { err.hidden = true; err.textContent = ''; }
      try {
        const drawer = document.querySelector('cart-drawer');
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', 1);
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          fd.append('sections', drawer.getSectionsToRender().map((s) => s.section));
          fd.append('sections_url', window.location.pathname);
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
        }
        const cfg = fetchConfig('javascript');
        cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete cfg.headers['Content-Type'];
        cfg.body = fd;
        const res = await (await fetch(window.routes.cart_add_url, cfg)).json();
        if (res.status) {
          if (err) { err.textContent = res.description || res.message || ''; err.hidden = false; }
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'iva-pdp-range', productVariantId: variantId, cartData: res });
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res);
          drawer.classList.remove('is-empty');
        } else {
          window.location = window.routes.cart_url;
        }
        if (label && btn.dataset.added) {
          label.textContent = btn.dataset.added;
          setTimeout(() => { label.textContent = original; }, 2000);
        }
      } catch (error) {
        console.error(error);
        if (err) { err.textContent = (window.cartStrings && window.cartStrings.error) || ''; err.hidden = false; }
      } finally {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    });
  }


  /* 7. Tabs (prototype activateTab: keep scroll position unless the bar is stuck) */
  function initTabs() {
    const wrap = document.querySelector('[data-ipd-tabs]');
    if (!wrap) return;
    const bar = wrap.querySelector('[role="tablist"]');
    const tabs = Array.from(wrap.querySelectorAll('[data-ipd-tab]'));
    const behavior = () => (reduceMotion.matches ? 'auto' : 'smooth');
    function activate(name, scroll) {
      const tab = tabs.find((t) => t.dataset.ipdTab === name);
      if (!tab) return;
      const headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      const stuck = bar.getBoundingClientRect().top <= headerH + 1;
      const y = window.scrollY;
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (scroll) {
        wrap.scrollIntoView({ block: 'start', behavior: behavior() });
      } else if (stuck) {
        window.scrollTo({ top: wrap.getBoundingClientRect().top + window.scrollY - headerH, behavior: 'auto' });
      } else {
        window.scrollTo({ top: y, behavior: 'auto' });
      }
      window.dispatchEvent(new Event('scroll'));
    }
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => activate(t.dataset.ipdTab, false));
      t.addEventListener('keydown', (e) => {
        let n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = tabs.length - 1;
        if (n === null) return;
        e.preventDefault();
        tabs[n].focus({ preventScroll: true });
        activate(tabs[n].dataset.ipdTab, false);
      });
    });
    document.addEventListener('ipd:open-tab', (e) => activate(e.detail.tab, !!e.detail.scroll));
    const hash = { '#beneficii': 'benefits', '#utilizare': 'usage', '#recenzii': 'reviews', '#judgeme_product_reviews': 'reviews' }[window.location.hash];
    if (hash) activate(hash, true);
  }

  /* 8. Reviews: "Scrie o recenzie" opens Judge.me's own form; links scroll to the widget */
  function initReviews() {
    const section = document.getElementById('ipd-reviews');
    document.querySelectorAll('[data-ipd-write-review]').forEach((b) => b.addEventListener('click', () => {
      if (!section) return;
      section.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      const jdgm = section.querySelector('.jm-action-buttons__button.jm-button--primary, .jdgm-write-rev-link, #jdgm-write-rev-button, .jdgm-write-rev-button');
      if (jdgm) setTimeout(() => jdgm.click(), 400);
    }));
    document.querySelectorAll('[data-ipd-goto-reviews]').forEach((a) => a.addEventListener('click', (e) => {
      if (!section) return;
      e.preventDefault();
      section.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }));
  }

  /* 9. Routine: morning/evening toggle, carousel arrows, progress text */
  function initRoutine() {
    const sec = document.querySelector('[data-ipd-routine]');
    if (!sec) return;
    const desktop = window.matchMedia('(min-width: 750px)');
    const panels = Array.from(sec.querySelectorAll('[data-ipd-routine-panel]'));
    panels.forEach((panel) => {
      const track = panel.querySelector('[data-ipd-routine-track]');
      const cards = Array.from(track.querySelectorAll('.ipd-routine__card'));
      const prev = panel.querySelector('[data-ipd-routine-prev]');
      const next = panel.querySelector('[data-ipd-routine-next]');
      const progress = panel.querySelector('[data-ipd-routine-progress]');
      const step = () => (cards[0] ? cards[0].getBoundingClientRect().width + 16 : track.clientWidth);
      const update = () => {
        if (panel.hidden) return;
        const i = Math.min(cards.length, Math.round(track.scrollLeft / Math.max(step(), 1)) + 1);
        const tpl = desktop.matches ? progress.dataset.templateD : progress.dataset.templateM;
        progress.textContent = (tpl || '').replace('[i]', i).replace('[n]', cards.length);
        prev.disabled = track.scrollLeft < 3;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
        const hideControls = track.scrollWidth <= track.clientWidth + 3;
        panel.querySelector('.ipd-routine__buttons').hidden = hideControls;
      };
      const behavior = () => (reduceMotion.matches ? 'auto' : 'smooth');
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: behavior() }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: behavior() }));
      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      panel.__ipdUpdate = update;
      update();
    });
    sec.querySelectorAll('[data-ipd-routine-tab]').forEach((b) => b.addEventListener('click', () => {
      sec.querySelectorAll('[data-ipd-routine-tab]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      panels.forEach((p) => {
        p.hidden = p.dataset.ipdRoutinePanel !== b.dataset.ipdRoutineTab;
        if (!p.hidden) { p.querySelector('[data-ipd-routine-track]').scrollLeft = 0; p.__ipdUpdate && p.__ipdUpdate(); }
      });
    }));
    sec.querySelectorAll('[data-ipd-back-to-product]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      const buy = document.getElementById('ipd-buy') || root;
      buy.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }));
  }


  /* 10. Wishlist heart on the photo (R04). Proxies Swym's own PDP button (#swym-atw-pdp-button), which Swym
     injects under the cart button after consent. Our heart only shows once that button exists; clicking it
     clicks Swym's button; the filled state mirrors Swym's "atw-button-added" class. Swym itself is untouched. */
  function initWishlist() {
    const heart = root.querySelector('[data-ipd-wishlist]');
    if (!heart) return;
    let swymBtn = null;
    let classObserver = null;
    const sync = () => {
      if (!swymBtn) return;
      const saved = swymBtn.classList.contains('atw-button-added');
      heart.setAttribute('aria-pressed', String(saved));
      heart.setAttribute('aria-label', saved ? heart.dataset.labelRemove : heart.dataset.labelAdd);
    };
    const attach = (btn) => {
      if (swymBtn === btn) return;
      swymBtn = btn;
      root.classList.add('ipd-has-swym');
      heart.hidden = false;
      if (classObserver) classObserver.disconnect();
      classObserver = new MutationObserver(sync);
      classObserver.observe(btn, { attributes: true, attributeFilter: ['class'] });
      sync();
    };
    const find = () => {
      const btn = root.querySelector('#swym-atw-pdp-button, .swym-atw-button-container .atw-button');
      if (btn) attach(btn);
      return !!btn;
    };
    if (!find()) {
      const mo = new MutationObserver(() => { if (find()) mo.disconnect(); });
      mo.observe(root, { childList: true, subtree: true });
    }
    heart.addEventListener('click', () => {
      if (!swymBtn || !swymBtn.isConnected) { swymBtn = null; find(); }
      if (swymBtn) swymBtn.click();
    });
  }

  function init() {
    initGallery();
    initPurchase();
    initSticky();
    initRatingLink();
    initRange();
    initTabs();
    initReviews();
    initRoutine();
    initWishlist();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();